import axios from 'axios';

const instance = axios.create({
  baseURL: location.host.includes('staging') ? '/staging-api' : '/api',
})

export default instance;